/**
 * `/orca/v3/loops/$loopId` — one loop: its definition, versions and runs, and the Run dialog. Registers the route eagerly with its guard and stylesheets;
 * the page itself is `$loopId.lazy.tsx`, so nothing it renders lands in the
 * always-loaded chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { v3BeforeLoad, v3Head } from "~/lib/v3-route.ts";

export const Route = createFileRoute("/orca/v3/loops/$loopId")({
  beforeLoad: v3BeforeLoad,
  head: v3Head,
});
